<template>
    <div class="relative">
        <p class="block font-bold text-sm text-gray-700">{{ label }}</p>
        <div
            class="relative w-full py-2 pl-3 pr-10 cursor-pointer text-left bg-white rounded-md border shadow-sm focus:outline-none sm:text-sm"
            :class="{
                ['border-red-500 focus:border-red-600 focus:ring-offset-red-200'] : errorMessage,
                ['border-gray-300 focus:border-gray-400 focus:ring-offset-gray-300'] : !errorMessage,
                ['bg-gray-400 opacity-50'] : disabled,
            }"

            @click="open = !open"
        >
            <span
                v-if="!selectedValue"
                class="block truncate text-gray-400"
            >{{ __('Choose') }}</span>
            <div v-else>
                <slot v-if="$slots.display" name="display" :value="selectedValue" :data="data" />
                <span
                    v-else
                    class="block truncate"
                >{{ selectedValue }}</span>
            </div>
            <span
                class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
            >
            <SvgIcon
                name="selector"
                class="text-gray-700"
                :size="20"
            />
            </span>
        </div>
        <div class="text-red-500 text-xs font-bold" v-if="errorMessage">{{ Array.isArray(errorMessage) ? errorMessage[0] : errorMessage }}</div>

        <transition
            enter-active-class="transition ease-out duration-200"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <ul class="rounded-md border absolute top-full mt-1 bg-white z-10 w-full shadow-md max-h-60 overflow-auto"
                v-if="open"
                :ref="ev => { input = ev }"
            >
                <slot name="empty-option"/>
                <slot :data="data" :active="selectedValue" :clicked="ev => { selectedValue = ev }" />
            </ul>
        </transition>
    </div>
</template>

<script>
import SvgIcon from 'UI/SvgIcon';
import { ref } from '@vue/reactivity';
import { watch } from '@vue/runtime-core';
import { usePage } from '@inertiajs/inertia-vue3';

export default {
    components: {
        SvgIcon,
    },
    props: ['label', 'data', 'modelValue', 'noneOption', 'id', 'name', 'disabled', 'emptyOption'],
    emits: ['update:modelValue'],

    setup(props, { emit }) {
        const
            options = props.data,
            selectedValue = ref(props.modelValue),
            open = ref(false),
            input = ref(null),
            active = ref(null);

        const errorMessage = ref(null);

        watch(selectedValue, (val, prevVal) => {
            emit('update:modelValue', val);

            errorMessage.value = null;
        })

        watch( () => usePage().props.value.errors, (error, oldError) => {
            if(props.name || props.id) errorMessage.value = error[props.name ? props.name : props.id];
        })

        const firstClick = ref(true);

        const clickOutside = function(el) {
            let targetEl = el.target;

            if(!firstClick.value){
                do {
                    if(targetEl == input.value) {
                        setTimeout(() => { open.value = false; }, 100);
                        return;
                    }
                    targetEl = targetEl.parentNode;
                } while (targetEl);

                open.value = false;
            }
            firstClick.value = false;
        }

        watch( () => open.value, (val, oldVal) => {

            if(val) $(window).on('click', clickOutside);
            else {
                $(window).unbind('click', clickOutside);
                firstClick.value = true;
            }
        })

        return {
            options,
            selectedValue,
            open,
            input,
            active,

            errorMessage,
        }
    },

    watch: {
        modelValue(val) { this.selectedValue = val; }
    },
}
</script>

<style>

</style>
